import { DynamicFormOptionConfig } from '@ng-dynamic-forms/core';
import { PickByType } from './pick-by-type.helper';

export function createOptionsFromEntities<T>(entities: T[], labelField: keyof PickByType<T, string>): DynamicFormOptionConfig<T>[] {
  return entities?.map(entity => ({
    label: entity[labelField as string],
    value: entity
  })) || [];
}
